// extracted by mini-css-extract-plugin
export var active = "Burger-module--active--vrox2";
export var buttonWrapper = "Burger-module--buttonWrapper--62ZVS";
export var container = "Burger-module--container--qgZUJ";
export var line = "Burger-module--line--eDpKv";